/**
 * Wheel of Fortune Toss Up tile sorter display component.
 */
angular.module('tgaAdmin').component('wofTilesorter', {
  controller: [
    '$scope',
    '$element',
    '$interval',
    function WofTilesorterController(scope, element, $interval) {
      /**
       * Play or Pause the tile reveal animation.
       */
      this.playPauseReveal = (forcedState) => {
        const isPlaying = !!this.isPlaying;
        const targetState = forcedState == null ? !isPlaying : !!forcedState;

        // Should play, but already playing.
        if (targetState && isPlaying) {
          return;
        }

        // Ensure playing state and timer are cleared.
        this.isPlaying = false;
        if (this.revealPromise != null) {
          $interval.cancel(this.revealPromise);
          this.revealPromise = null;
        }

        // Reset letterboard visual state.
        const letterboard = $(this.letterboardSelector);
        letterboard.find('.tile').removeClass('tile-hidden tile-current');

        // Reset sortable visual state, or bail if there is no sortable.
        if (this.sortable == null || this.sortableContainer == null) {
          return;
        }
        this.sortableContainer.find('.tile-current').removeClass('tile-current');

        // End here if we were trying to pause.
        if (!targetState) {
          return;
        }

        // Get ordered elements, or bail if there aren't any.
        const sortedElements = this.sortable.getDraggableElementsForContainer(this.sortableContainer[0]);
        if (sortedElements.length === 0) {
          return;
        }

        // Set up play variables, hide letters on letterboard.
        const revealSpeed = this.revealSpeed > 10 ? this.revealSpeed : this.revealSpeed * 1000;
        this.isPlaying = true;
        letterboard.find('.tile.letter:not(.specialChar)').addClass('tile-hidden');

        // Callback to reveal a tile.
        const revealNextOrEnd = () => {
          // If we should stop, abort.
          if (
            !this.isPlaying
            || sortedElements.length === 0
            || !element.is(':visible')
          ) {
            this.playPauseReveal(false);
            return false;
          }

          // Highlight current element in sortables.
          const currentElement = $(sortedElements.shift());
          this.sortableContainer.find('.tile-current').removeClass('tile-current');
          currentElement.addClass('tile-current');

          // Reveal and highlight current element, remove highlight from previous.
          const tileId = currentElement.data('tile');
          letterboard.find('.tile-current').removeClass('tile-current');
          letterboard.find(`.tile[tile='${tileId}']`).removeClass('tile-hidden').addClass('tile-current');

          return true;
        };

        // Reveal the first tile immediately, then start timer if there are more.
        if (revealNextOrEnd()) {
          this.revealPromise = $interval(revealNextOrEnd, revealSpeed, sortedElements.length + 1);
        }
      };

      /**
       * Creates the sortable elements according to the tile values.
       */
      this.createSortables = () => {
        if (this.sortableContainer == null) {
          return;
        }

        // Ensure reveal animation is stopped before repopulating.
        this.playPauseReveal(false);

        // Clear existing sortable tiles.
        this.sortableContainer.empty();

        // Create/collect letter tiles with their sentence index and potential sort order.
        const elementsWithOrder = [];
        _.forEach(this.tiles, (tile, index) => {
          if (tile.specialChar) {
            return;
          }
          const {
            row, col, letter, order,
          } = tile;
          elementsWithOrder.push([
            `<span class="tile" data-index="${index}" data-tile="${row}_${col}">${letter}</span>`,
            order,
          ]);
        });

        // Sort elements by `order` before appending them to the container
        const sortedElements = _.sortBy(elementsWithOrder, ([, order]) => order);
        _.forEach(sortedElements, ([el]) => {
          this.sortableContainer.append(el);
        });
      };

      /**
       * Set or Update the `order` property of the tiles based on element sort order.
       */
      this.saveOrder = () => {
        if (this.sortable == null || this.sortableContainer == null) {
          return;
        }

        // Set tiles `order` property by DOM order
        const sortedTiles = this.sortable.getDraggableElementsForContainer(this.sortableContainer[0]);
        _.forEach(sortedTiles, (tileEl, sortIndex) => {
          const tileIndex = tileEl.dataset.index;
          if (_.has(this.tiles, tileIndex)) {
            this.tiles[tileIndex].order = sortIndex;
          }
        });

        this.onUpdate();
      };

      /**
       * Randomize the tile order.
       */
      this.shuffleTiles = () => {
        if (this.sortable == null || this.sortableContainer == null) {
          return;
        }

        // Ensure reveal animation is stopped before shuffling.
        this.playPauseReveal(false);

        const sortedTiles = this.sortable.getDraggableElementsForContainer(this.sortableContainer[0]);
        const shuffledTiles = _.shuffle(sortedTiles);
        this.sortableContainer.append(shuffledTiles);
        this.saveOrder();
      };

      /**
       * Reset the tile order to default.
       */
      this.resetTiles = () => {
        if (this.tiles == null) {
          return;
        }

        // Delete `order` property from tiles.
        _.forEach(this.tiles, (tile) => {
          delete tile.order;
        });

        // Re-populate sortable tiles.
        this.createSortables();

        this.onUpdate();
      };

      /**
       * Controller callback for bound variable changes.
       */
      this.$onChanges = (changesObj) => {
        this.playPauseReveal(false);

        if (changesObj.tiles) {
          this.createSortables();
        }
      };

      /**
       * Controller callback for scope destruction.
       */
      this.$onDestroy = () => {
        this.playPauseReveal(false);
      };

      /**
       * Controller callback for initialization.
       */
      this.$onInit = () => {
        this.sortableContainer = element.find('.sortable');
        // eslint-disable-next-line new-cap
        this.sortable = new Sortable.default(this.sortableContainer[0], { draggable: '.tile' });
        this.isPlaying = false;
        this.revealPromise = null;

        // Highlight selected and corresponding board tile during drag.
        this.sortable.on('sortable:start', (event) => {
          this.playPauseReveal(false);
          const $sourceEl = $(event.data.dragEvent.data.source);
          $sourceEl.addClass('dragging');
          if (this.letterboardSelector != null) {
            const tileId = $sourceEl.data('tile');
            $(this.letterboardSelector).find(`.tile[tile='${tileId}']`).addClass('dragging');
          }
        });

        // Remove highlights when drag done.
        this.sortable.on('sortable:stop', (event) => {
          this.sortableContainer.find('.dragging').removeClass('dragging');
          if (this.letterboardSelector != null) {
            $(this.letterboardSelector).find('.dragging').removeClass('dragging');
          }

          if (event.data.newIndex !== event.data.oldIndex) {
            this.saveOrder();
          }
        });

        this.createSortables();
      };
    },
  ],
  template:
    '<div class="sortable"></div>'
    + '<div ng-if="$ctrl.tiles != null && $ctrl.tiles.length > 1">'
    + '<button class="btn btn-primary" ng-click="$ctrl.shuffleTiles()">Shuffle Tiles</button> '
    + '<button class="btn btn-primary" ng-click="$ctrl.resetTiles()">Reset Order</button> '
    + '<button class="btn btn-primary" ng-show="!$ctrl.isPlaying" ng-click="$ctrl.playPauseReveal(true)">'
    + '<span class="fa fa-play"></span> Play'
    + '</button> '
    + '<button class="btn btn-success" ng-show="$ctrl.isPlaying" ng-click="$ctrl.playPauseReveal(false)">'
    + '<span class="fa fa-pause"></span> Pause'
    + '</button> '
    + '</div>',
  bindings: {
    tiles: '<*',
    revealSpeed: '<',
    letterboardSelector: '@',
    onUpdate: '&',
  },
});
